import React from "react";
import { Col, Container, Row } from "react-bootstrap";
export default function SiteMap() {
  const links = [
    {
      href: "https://www.pureionia.com/",
      label: "Home Page",
    },
    { href: "https://www.pureionia.com/about-us", label: "About Us" },
    {
      label: "Products",
      children: [
        {
          href: "https://www.pureionia.com/products/ionia-en-7p-alkaline-water-machine",
          label: "Ionia En 7p Alkaline Water Machine",
        },
        {
          href: "https://www.pureionia.com/products/ionia-iq-400u-alkaline-water-machine",
          label: "Ionia Iq 400u Alkaline Water Machine",
        },
        {
          href: "https://www.pureionia.com/products/ionia-sm-s230tl-alkaline-water-machine",
          label: "Ionia Sm S230tl Alkaline Water Machine",
        },
        {
          href: "https://www.pureionia.com/products/ionia-x-blue-alkaline-water-machine",
          label: "Ionia X Blue Alkaline Water Machine",
        },
      ],
    },
    { href: "https://www.pureionia.com/contacts", label: "Contacts" },
    {
      href: "https://www.pureionia.com/health-benefits",
      label: "Health Benefits",
    },
    { href: "https://www.pureionia.com/rnd", label: "Rnd" },
    { href: "https://www.pureionia.com/buy-products", label: "Buy Products" },
    {
      label: "Blog",
      children: [
        {
          href: "https://www.pureionia.com/blog/use-of-ionizer-water-machine-good-or-bad",
          label: "Use Of Ionizer Water Machine Good Or Bad",
        },
        {
          href: "https://www.pureionia.com/blog/top-5-alkaline-water-ionizer-machines-in-india",
          label: "Top 5 Alkaline Water Ionizer Machines In India",
        },
        {
          href: "https://www.pureionia.com/blog/the-benefits-of-alkaline-water-and-why-you-need-an-ionizer-machine-in-india",
          label:
            "The Benefits Of Alkaline Water And Why You Need An Ionizer Machine In India",
        },
      ],
    },
    {
      href: "https://www.pureionia.com/privacy-policy-2",
      label: "Privacy Policy",
    },
    {
      href: "https://www.pureionia.com/refunds-and-cancellations",
      label: "Refunds And Cancellations",
    },
    {
      href: "https://www.pureionia.com/shipping-and-delivery-policy",
      label: "Shipping And Delivery Policy",
    },
    {
      href: "https://www.pureionia.com/terms-and-condition",
      label: "Terms And Condition",
    },
  ];

  return (
    <>
      <Container>
        <Row>
          <Col>
            <div className="container mt-4">
              <h1 className="text-center mb-4">Sitemap</h1>
              <ul className="list-group">
                {links.map((link, index) => (
                  <li className="list-group-item" key={index}>
                    <a href={link.href} className="text-decoration-none">
                      {link.label}
                    </a>
                    {link.children && (
                      <ul className="list-group mt-2">
                        {link.children.map((subLink, subIndex) => (
                          <li className="list-group-item" key={subIndex}>
                            <a
                              href={subLink.href}
                              className="text-decoration-none"
                            >
                              {subLink.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
